import { render, staticRenderFns } from "./PolygonsStatistics.vue?vue&type=template&id=7bace4a1&scoped=true&"
import script from "./PolygonsStatistics.vue?vue&type=script&lang=js&"
export * from "./PolygonsStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bace4a1",
  null
  
)

export default component.exports